import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences, props } from 'app/pwa/app.cerebral';

import { SearchDropdown } from '../../elements';
import { useText } from 'common/hooks';

type Props = {
  readonly level: string;
  readonly options: { [key: string]: string };
};

const deps = {
  campaign: state.account.joinCampaign.campaign,
  value: state.account.joinCampaign.fields[props`level`],
  dropdown: state.account.joinCampaign.dropdown,
  hideOtherDropdown: sequences`account.joinCampaign.hideOtherDropdown`,
  toggleShowDropdown: sequences`account.joinCampaign.toggleShowDropdown`,
  showDropdown: sequences`account.joinCampaign.showDropdown`,
  optionSelected: sequences`account.joinCampaign.optionSelected`,
  optionChanged: sequences`account.joinCampaign.optionChanged`,
};

function Dropdown({
  campaign,
  value,
  dropdown,
  hideOtherDropdown,
  toggleShowDropdown,
  showDropdown,
  optionSelected,
  optionChanged,
  level,
  options,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <SearchDropdown
      placeholder={
        level === 'section'
          ? t(`account.join_campaign.form.choose`, {
              sectionTerm:
                campaign.sectionTerm === 'other'
                  ? campaign.specifiedTerm
                  : t(
                      `campaign.section_terms.${
                        campaign.sectionTerm || 'section'
                      }`,
                      { smart_count: 1 }
                    ),
            })
          : t(`account.join_campaign.form.choose_${level}`)
      }
      options={options}
      value={value}
      onClick={event => {
        event.stopPropagation();
        hideOtherDropdown({ dropdown: level });
      }}
      onFocus={() => {
        showDropdown({ dropdown: level });
      }}
      onChange={event => {
        optionChanged({
          value: event.target.value,
          field: level,
        });
      }}
      onIconClick={event => {
        event.stopPropagation();
        toggleShowDropdown({ dropdown: level });
      }}
      onDropdownItemClick={({ key, option }) => {
        optionSelected({ key: key, text: option, field: level });
      }}
      dropdownVisible={dropdown === level}
    />
  );
}

export default connect<Props, typeof deps>(deps, Dropdown);
